const SesAyarlari = () => {
  return (
    <div className="relative group">
    <button 
      className="px-3 py-1 text-gray-700 hover:bg-gray-300 rounded transition-colors flex items-center gap-1"
      title="Ses Ayarları"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z" />
      </svg>
    </button>

    {/* Ses Kontrol Paneli */}
    <div className="absolute right-0 mt-2 bg-white rounded-lg shadow-lg p-4 w-64 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-[60]">
      <div className="space-y-4">
        {/* Ses Seviyesi Kontrolü */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-700">Ses Seviyesi</span>
            <span className="text-xs text-gray-500" id="volume-value"></span>
          </div>
          <input
            type="range"
            min="0"
            max="1"
            step="0.1"
            defaultValue="1"
            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-purple-600"
            onChange={(e) => {
              const value = e.target.value;
              // Store the value in a data attribute on the slider itself
              e.target.setAttribute('data-value', value);
              document.getElementById('volume-value').textContent = `${Math.round(value * 100)}%`;
            }}
          />
        </div>

        {/* Konuşma Hızı Kontrolü */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-700">Konuşma Hızı</span>
            <span className="text-xs text-gray-500" id="rate-value"></span>
          </div>
          <input
            type="range"
            min="0.5"
            max="2"
            step="0.1"
            defaultValue="1"
            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-purple-600"
            onChange={(e) => {
              const value = e.target.value;
              // Store the value in a data attribute on the slider itself
              e.target.setAttribute('data-value', value);
              document.getElementById('rate-value').textContent = `${value}x`;
            }}
          />
        </div>

        {/* Test Butonu */}
        <button
          onClick={() => {
            if (window.speechSynthesis) {
              const utterance = new SpeechSynthesisUtterance('Bu bir test mesajıdır.');
              utterance.lang = 'tr-TR';
              
              // Get current values from sliders
              const volumeControl = document.querySelector('input[type="range"][min="0"][max="1"]');
              const rateControl = document.querySelector('input[type="range"][min="0.5"][max="2"]');
              
              // Apply settings to this utterance
              if (volumeControl) {
                const volumeValue = volumeControl.getAttribute('data-value') || volumeControl.value;
                utterance.volume = parseFloat(volumeValue);
              }
              
              if (rateControl) {
                const rateValue = rateControl.getAttribute('data-value') || rateControl.value;
                utterance.rate = parseFloat(rateValue);
              }
              
              window.speechSynthesis.speak(utterance);
            }
          }}
          className="w-full py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors text-sm font-medium"
        >
          Test Et
        </button>
      </div>
    </div>
  </div>
  )
}

export default SesAyarlari